module.exports = __webpack_public_path__ + "static/img/共享运营平台6.1e0726eb.png";